import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import NavBaseButton from "./components/NavBaseButton";
import { LANGUAGE_OPTIONS, LANGUAGES, getLanguageIndex } from "./utils/languageUtils";

class LanguageMenu extends React.Component {
  constructor(props) {
    super(props);
    const currentLanguage = props.strings.getLanguage();
    const index = getLanguageIndex(currentLanguage);

    this.state = {
      anchorEl: null,
      selectedIndex: index
    };
    this.strings = props.strings;
    this.setLanguage = props.setLanguage;
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
    const selectedLanguage = LANGUAGE_OPTIONS[index].lang;
    this.setLanguage(selectedLanguage);
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <div>
        <NavBaseButton
          color="inherit"
          aria-owns={anchorEl ? "language-menu" : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          Kieli/Språk/Language
        </NavBaseButton>
        <Menu
          id="language-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {LANGUAGE_OPTIONS.map((language, index) => (
            <MenuItem
              dense={true}
              key={language.text}
              selected={index === this.state.selectedIndex}
              onClick={(event) => this.handleMenuItemClick(event, index)}
              className="!font-light !text-sm"
              component="li"
              lang={language.lang}
            >
              {language.text}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

export default LanguageMenu;
